import { fetchApi } from '@/config/axiosSetting';
import {
  GetOwnerInformationQueryParamsType,
  GetOwnerInformationQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';

export const getOwnerInformationFunction = (
  params: GetOwnerInformationQueryParamsType,
): Promise<GetOwnerInformationQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params?.id}/accident_users/culprit/user_information/owner/`,
    { params },
  );
};
